import { render, staticRenderFns } from "./CvcMigration.vue?vue&type=template&id=01677990&scoped=true"
import script from "./CvcMigration.vue?vue&type=script&lang=js"
export * from "./CvcMigration.vue?vue&type=script&lang=js"
import style0 from "./CvcMigration.vue?vue&type=style&index=0&id=01677990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01677990",
  null
  
)

export default component.exports